export enum TestActions {
    TEST_PORTLET = 'Test Portlet',
    ENABLE_LOGS = 'Enable Logs',
    DISABLE_LOGS = 'Disable Logs',
    CHANGE_BASE_URL = 'Change Base Url'
}
